<template>
  <transition name="fade-zoom">
    <div class="modal-media" v-if="src">
      <div class="modal-background" @click.prevent="$emit('close')" />
      <div class="modal-body">
        <a href="#" @click.prevent="$emit('close')" class="modal-close">X</a>
        <video autoplay loop class="modal-video" width="100%" :src="src" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal-media',
  props: {
    src: String,
  },
};
</script>

<style lang="scss" scoped>
  .modal-media {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-background {
      position: absolute;
      background-color: rgba(black, .5);
      width: 100%;
      height: 100%;
    }
    .modal-body {
      width: 60%;
      position: relative;
      z-index: 1;
    }
    .modal-close {
      padding: 7px 12px;
      font-size: 18px;
      line-height: 18px;
      color: black;
      background-color: white;
      position: absolute;
      top: -15px;
      right: -15px;
      text-decoration: none;
      transition: transform .1s;
      z-index: 2;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalMedia.vue